module.exports = __webpack_public_path__ + "static/media/logo-suma-azul.cee1e1cb.png";